export const CARDTYPE_CONIG_CONSTANT = {
    LOAD_CARDTYPE_CONFIG: 'LOAD_CARDTYPE_CONFIG'
};